setTimeout(function() {
  const products_on_page = document.getElementById('product-grid');
  const nextUrl = document.getElementById('paginateNext');
  let next_url = nextUrl.dataset.nextUrl;

  const load_more_btn = document.getElementsByClassName('load-more_btn')[0];
  const load_more_spinner = document.getElementsByClassName('load-more_spinner')[0];
  let loading = false;  // To prevent multiple requests while already loading
  let scrollTimeout;  // Timeout ID for scroll event

  async function getNextPage() {
    try {
      let res = await fetch(next_url);
      return await res.text();
    } catch (error) {
      console.log(error);
    }
  }

  async function loadMoreProducts() {
    const products_on_page_two = document.getElementById('product-grid');
    if (!next_url || loading) return;  // Stop if there is no next page or already loading
    loading = true;
    
    load_more_btn.style.display = 'none';
    load_more_spinner.style.display = 'block';
    
    let nextPage = await getNextPage();
    const parser = new DOMParser();
    const nextPageDoc = parser.parseFromString(nextPage, 'text/html');
    
    load_more_spinner.style.display = 'none';

    const productgrid = nextPageDoc.getElementById('product-grid');
    const new_products = productgrid.getElementsByClassName('grid__item');
    const newUrl = nextPageDoc.getElementById('paginateNext');
    const new_url = newUrl ? newUrl.dataset.nextUrl : null;

    if (new_url) {
      load_more_btn.style.display = 'flex';
    }
    next_url = new_url;
    
    for (let i = 0; i < new_products.length; i++) {
      products_on_page_two.appendChild(new_products[i]);
    }
    
    loading = false;
  }

  // Function to detect if the user has scrolled near the bottom of the page
  function onScroll() {
    // Clear the previous timeout if it's still running
    if (scrollTimeout) {
      clearTimeout(scrollTimeout);
    }

    // Set a new timeout to trigger the load after 1 second
    scrollTimeout = setTimeout(function() {
      if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 800) {
        loadMoreProducts();
      }
    }, 900);
  }

  // Attach the scroll event listener
  window.addEventListener('scroll', onScroll);
  
  // Add class to the element with id #spining-icons
  const spiningIcon = document.getElementById('spining_icons');
  spiningIcon.classList.add('loadingMore_button');  // Replace 'your-class' with the class you want to add

}, 1000);  // Execute after 1 second
